<template>
    <main class="home-bg-image">
        <div class="wrapper">
            <header-section />
            <flash-messages />
            <slot />
            <footer-section />
        </div>
    </main>
</template>

<script>
import FlashMessages from '@/Shared/FlashMessages'
import HeaderSection from '@/Shared/HeaderSection'
import FooterSection from '@/Shared/FooterSection'

export default {
    components: {
      HeaderSection,
      FlashMessages,
      FooterSection,
    },
    methods: {

    }
}
</script>
